/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const StorageStrategy = core.serialization.enum_([
    "RAINBOW_TABLES",
    "CELL_HISTORY",
    "HYPERCUBE",
    "QUICKSTORE",
    "DUCKDB",
    "FOREIGNDB",
    "MEMCSV",
]);
